var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupabaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 14.073,
    x2: 14.073,
    y1: 8.468,
    y2: 36.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7dffce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50c08d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M24.2,30V6.3c0-1.8-2.3-2.6-3.4-1.2L4.5,25.9c-1.3,1.7-0.1,4.1,2,4.1H24.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140728474547789280440000018204366184369975479_",
    x1: 34.249,
    x2: 34.249,
    y1: 48.404,
    y2: 19.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7dffce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50c08d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000140728474547789280440000018204366184369975479_)",
    d: "M24,18.4v23.7c0,1.8,2.4,2.6,3.5,1.2 l16.4-20.7c1.3-1.7,0.1-4.1-2.1-4.1H24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupabaseIcon);
export default __webpack_public_path__ + "static/media/supabaseIcon.f5ab93a393d02593a9110c45b485952f.svg";
export { ForwardRef as ReactComponent };